// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.orgs-page {
  padding: 32px 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .orgs-page {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .orgs-page {
    padding: 16px 16px 28px;
  }
}

.orgs-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 16px;
}
@media (max-width: 640px) {
  .orgs-header {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
}
.orgs-header__left {
  flex: 1;
}
.orgs-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.orgs-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.2;
}
@media (max-width: 640px) {
  .orgs-header__title {
    font-size: 22px;
  }
}
.orgs-header__count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgb(0, 173, 208), #008ba7);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  letter-spacing: 0.02em;
}
.orgs-header__count--search {
  background: linear-gradient(135deg, rgb(255, 121, 0), #d66600);
}
.orgs-header__count-label {
  font-size: 11px;
  font-weight: 500;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.orgs-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
  color: #ccc;
}
.orgs-breadcrumb li {
  display: flex;
  align-items: center;
}
.orgs-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
  font-size: 11px;
}
.orgs-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.orgs-breadcrumb li a:hover {
  color: rgb(0, 173, 208);
}
.orgs-breadcrumb li.orgs-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.orgs-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  padding: 14px 20px;
  background: #f1f1f2;
  border-radius: 8px;
  border: 1px solid #e7eaec;
}
@media (max-width: 767px) {
  .orgs-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 12px 16px;
  }
}
.orgs-toolbar__left {
  flex: 1;
  max-width: 360px;
}
@media (max-width: 767px) {
  .orgs-toolbar__left {
    max-width: none;
  }
}
.orgs-toolbar__right {
  display: flex;
  align-items: center;
  gap: 12px;
}
@media (max-width: 640px) {
  .orgs-toolbar__right {
    justify-content: space-between;
  }
}

.orgs-search {
  position: relative;
  width: 100%;
}
.orgs-search__icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #ccc;
  font-size: 13px;
  pointer-events: none;
}
.orgs-search__input {
  width: 100%;
  padding: 9px 36px 9px 34px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  outline: none;
}
.orgs-search__input::placeholder {
  color: #ccc;
}
.orgs-search__input:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}
.orgs-search__clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: #ccc;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  padding: 0;
  transition: background 0.15s ease;
}
.orgs-search__clear:hover {
  background: #676a6c;
}

.orgs-view-toggle {
  display: flex;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}
.orgs-view-toggle__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 34px;
  border: none;
  background: transparent;
  color: #ccc;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 14px;
  padding: 0;
}
.orgs-view-toggle__btn:not(:last-child) {
  border-right: 1px solid #e7eaec;
}
.orgs-view-toggle__btn:hover {
  color: #676a6c;
  background: #f1f1f2;
}
.orgs-view-toggle__btn--active {
  background: #6d6e71;
  color: #fff;
}
.orgs-view-toggle__btn--active:hover {
  background: #6d6e71;
  color: #fff;
}

.orgs-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-decoration: none;
  line-height: 1.4;
}
.orgs-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.orgs-btn--primary:hover {
  background: #4cae4c;
  border-color: #4cae4c;
}
.orgs-btn--back {
  background: #fff;
  color: #676a6c;
  border-color: #e7eaec;
}
.orgs-btn--back:hover {
  background: #f1f1f2;
  border-color: #ccc;
}
.orgs-btn--outline {
  background: #fff;
  color: rgb(0, 173, 208);
  border-color: rgb(0, 173, 208);
}
.orgs-btn--outline:hover {
  background: rgba(0, 173, 208, 0.06);
}

.orgs-content {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e7eaec;
  overflow: hidden;
  min-height: 200px;
}

.orgs-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.orgs-state > i {
  font-size: 36px;
  margin-bottom: 16px;
}
.orgs-state p {
  font-size: 15px;
  color: #676a6c;
  margin: 0 0 16px;
}
.orgs-state--loading {
  padding: 48px 20px;
}
.orgs-state--error > i {
  color: rgb(245, 67, 89);
}
.orgs-state--error p {
  color: #676a6c;
}
.orgs-state--empty > i {
  color: #ccc;
}
.orgs-state--empty p {
  color: #ccc;
}

.orgs-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 24px;
}
@media (max-width: 640px) {
  .orgs-cards {
    grid-template-columns: 1fr;
    padding: 16px;
    gap: 12px;
  }
}

::ng-deep .orgs-content .table-responsive {
  overflow-x: auto;
}
::ng-deep .orgs-content .table-responsive table {
  width: 100%;
  margin-bottom: 0;
  border-collapse: collapse;
}
::ng-deep .orgs-content .table-responsive table thead tr {
  background: #f1f1f2;
}
::ng-deep .orgs-content .table-responsive table thead tr th {
  padding: 12px 16px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
  border-bottom: 2px solid #e7eaec;
  border-top: none;
  white-space: nowrap;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: default;
}
::ng-deep .orgs-content .table-responsive table thead tr th.cursor-pointer {
  cursor: pointer;
}
::ng-deep .orgs-content .table-responsive table thead tr th.cursor-pointer:hover {
  color: rgb(0, 173, 208);
}
::ng-deep .orgs-content .table-responsive table thead tr th.cursor-pointer i {
  margin-left: 4px;
  font-size: 12px;
}
::ng-deep .orgs-content .table-responsive table tbody tr {
  transition: background-color 0.12s ease;
  border-bottom: 1px solid #e7eaec;
}
::ng-deep .orgs-content .table-responsive table tbody tr:hover {
  background-color: rgba(0, 173, 208, 0.03);
}
::ng-deep .orgs-content .table-responsive table tbody tr:nth-of-type(even) {
  background-color: rgba(241, 241, 242, 0.5);
}
::ng-deep .orgs-content .table-responsive table tbody tr:nth-of-type(even):hover {
  background-color: rgba(0, 173, 208, 0.03);
}
::ng-deep .orgs-content .table-responsive table tbody tr td {
  padding: 12px 16px;
  font-size: 13px;
  color: #676a6c;
  vertical-align: middle;
  border-top: none;
}
::ng-deep .orgs-content .table-responsive table tbody tr td a:not(.invn-act):not(.invn-keynum) {
  color: #676a6c;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s ease;
}
::ng-deep .orgs-content .table-responsive table tbody tr td a:not(.invn-act):not(.invn-keynum):hover {
  color: rgb(0, 173, 208);
}
::ng-deep .orgs-content .table-responsive table tfoot tr {
  background: #f1f1f2;
  border-top: 1px solid #e7eaec;
}
::ng-deep .orgs-content .table-responsive table tfoot tr td {
  padding: 12px 16px;
  border-top: none;
}
::ng-deep #holder {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
}
::ng-deep #holder > li {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #676a6c;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
::ng-deep #holder > li:hover {
  background: #f1f1f2;
  border-color: #ccc;
}
::ng-deep #holder > li.active {
  background: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
::ng-deep #holder > li.active:hover {
  background: #606164;
}
::ng-deep #holder > li.separator {
  border: none;
  background: none;
  cursor: default;
  min-width: auto;
  padding: 0 4px;
  color: #ccc;
}
::ng-deep #holder > li.separator::before {
  content: "...";
}
::ng-deep #holder > li.separator:hover {
  background: none;
}
::ng-deep .wide-per-page {
  width: 70px;
  display: inline-block;
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  color: #676a6c;
  background: #fff;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
::ng-deep .wide-per-page:focus {
  border-color: rgb(0, 173, 208);
  outline: none;
}
::ng-deep .sample {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgb(255, 121, 0);
  background: rgba(255, 121, 0, 0.1);
  border-radius: 3px;
}
::ng-deep .team-actions {
  white-space: nowrap;
  width: auto;
  vertical-align: middle !important;
}
::ng-deep .team-actions__opr {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 6px;
  font-size: 13px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  cursor: pointer;
  line-height: 1;
}
::ng-deep .team-actions .btn-info {
  background: rgba(0, 173, 208, 0.08);
  color: rgb(0, 173, 208);
  border-color: rgba(0, 173, 208, 0.15);
}
::ng-deep .team-actions .btn-info:hover {
  background: rgb(0, 173, 208);
  color: #fff;
  transform: scale(1.08);
}
::ng-deep .team-actions .btn-danger {
  background: rgba(245, 67, 89, 0.08);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.15);
}
::ng-deep .team-actions .btn-danger:hover {
  background: rgb(245, 67, 89);
  color: #fff;
  transform: scale(1.08);
  box-shadow: 0 2px 8px rgba(245, 67, 89, 0.3);
}
::ng-deep .team-actions .btn-primary {
  background: rgba(105, 190, 40, 0.08);
  color: rgb(105, 190, 40);
  border-color: rgba(105, 190, 40, 0.15);
}
::ng-deep .team-actions .btn-primary:hover {
  background: rgb(105, 190, 40);
  color: #fff;
  transform: scale(1.08);
}
::ng-deep .team-actions .btn-warning {
  background: rgba(255, 121, 0, 0.08);
  color: rgb(255, 121, 0);
  border-color: rgba(255, 121, 0, 0.15);
}
::ng-deep .team-actions .btn-warning:hover {
  background: rgb(255, 121, 0);
  color: #fff;
  transform: scale(1.08);
}
::ng-deep .f-btn--bgw {
  background: #fff;
  color: #676a6c;
  border: 1px solid #e7eaec;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  transition: all 0.15s ease;
}
::ng-deep .f-btn--bgw:hover {
  border-color: rgb(105, 190, 40);
  color: rgb(105, 190, 40);
}
::ng-deep .group-profile-img {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  transition: transform 0.15s ease;
}
::ng-deep .group-profile-img:hover {
  transform: scale(1.1);
}
::ng-deep .form-group {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
::ng-deep .form-group label {
  font-size: 12px;
  font-weight: 600;
  color: #6d6e71;
  margin: 0;
  white-space: nowrap;
}
::ng-deep .search-res {
  font-size: 16px;
  font-weight: 600;
  color: #6d6e71;
  padding: 16px 16px 8px;
  margin: 0;
}

::ng-deep .swal2-container {
  padding: 30px;
}
@media only screen and (min-width: 768px) {
  ::ng-deep .swal2-container {
    padding-left: 220px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .swal2-container {
    padding-top: 50px;
    padding-inline: 15px;
  }
}
::ng-deep .swal2-container .swal2-modal {
  align-self: start !important;
  grid-row: auto !important;
  height: auto !important;
  margin: 0 !important;
  border: 1px solid #e7eaec !important;
  border-radius: 8px !important;
  padding: 20px 28px 22px !important;
  position: static !important;
  background-color: #fff !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08) !important;
}
::ng-deep .swal2-container .swal2-modal > * {
  margin-block: 0 !important;
}
::ng-deep .swal2-container .swal2-modal > :not(:last-child) {
  margin-bottom: 14px !important;
}
::ng-deep .swal2-container .swal2-actions {
  margin-bottom: 0 !important;
  grid-gap: 10px !important;
}
::ng-deep .swal2-container .swal2-actions button {
  min-width: 130px !important;
  margin: 0 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  padding: 10px 20px !important;
  border-radius: 6px !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
::ng-deep .swal2-container .swal2-actions .swal2-confirm {
  background-color: rgb(105, 190, 40) !important;
}
::ng-deep .swal2-container .swal2-actions .swal2-confirm:hover {
  background-color: #4cae4c !important;
  color: #fff;
}
::ng-deep .swal2-container h2 {
  font-size: 18px !important;
  line-height: 1.3 !important;
  font-weight: 600 !important;
  color: #6d6e71 !important;
}
::ng-deep .swal2-container .swal2-html-container {
  font-size: 14px !important;
  line-height: 150% !important;
}

::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 560px;
    margin: 60px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  outline: 0;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 20px;
  font-weight: bold;
  color: #ccc;
  opacity: 0.6;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
}
::ng-deep .modal .modal-dialog .modal-content .close:hover {
  opacity: 1;
  color: #676a6c;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body {
  padding: 24px 28px 28px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #6d6e71;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text] {
  width: 100%;
  padding: 10px 14px;
  font-size: 14px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]::placeholder {
  color: #ccc;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]:focus, ::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]:focus-visible {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
  outline: none;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: all 0.15s ease;
  border-color: rgb(105, 190, 40);
  background-color: rgb(105, 190, 40);
}
::ng-deep .modal .f-btn:hover {
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--dngr {
  background-color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
}
::ng-deep .modal .f-btn--dngr:hover {
  background-color: #f31c37;
}
::ng-deep .modal .f-btn--info {
  font-size: 12px;
  padding: 6px 12px;
  background-color: rgb(0, 173, 208);
  border-color: rgb(0, 173, 208);
}
::ng-deep .modal .f-btn--info:hover {
  background-color: #008ba7;
}
::ng-deep .modal .f-btn--wrng {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
::ng-deep .modal .f-btn--wrng:hover {
  background-color: #d66600;
}
::ng-deep .modal .f-btn--seagrn {
  background-color: #1dc5a3;
  border-color: #1dc5a3;
}
::ng-deep .modal .f-btn--seagrn:hover {
  background-color: #1aaf91;
}
::ng-deep .modal .hidden {
  display: none;
}

::ng-deep .modal-open {
  overflow: hidden;
}

.reset-input {
  position: relative;
}
.reset-input .reset-close {
  display: none;
  position: absolute;
  top: 0;
  right: 15px;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  background: #ccc;
  border: none !important;
  text-align: center;
  font-size: 12px;
  padding: 0 !important;
  height: 16px !important;
  width: 16px !important;
  color: #fff;
  line-height: 1.2 !important;
  transform: rotate(45deg) !important;
  cursor: pointer;
}
.reset-input:hover .reset-close {
  display: block;
}
.reset-input th {
  position: relative;
}
.reset-input th input[type=search] {
  width: 100% !important;
}
.reset-input th .reset-close {
  right: 25px;
}
.reset-input th:hover .reset-close {
  display: block;
}

::ng-deep .roster_popup .dialogbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99999;
}
::ng-deep .roster_popup .dialogbox__wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 60px 20px;
  overflow-y: auto;
  height: 100%;
}
::ng-deep .roster_popup .dialogbox__inner {
  width: min(560px, 100%);
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: #fff;
  border: none;
  padding: 0;
}
::ng-deep .roster_popup .dialogbox__hdr {
  padding: 18px 24px;
  background: #f1f1f2;
  border-bottom: 1px solid #e7eaec;
  position: relative;
}
::ng-deep .roster_popup .dialogbox__hdr h2 {
  font-size: 17px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
}
::ng-deep .roster_popup .dialogbox__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}
::ng-deep .roster_popup .dialogbox__close::before, ::ng-deep .roster_popup .dialogbox__close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 55%;
  background-color: #676a6c;
  border-radius: 2px;
}
::ng-deep .roster_popup .dialogbox__close::before {
  transform: translate(-50%, -50%) rotate(-45deg);
}
::ng-deep .roster_popup .dialogbox__close::after {
  transform: translate(-50%, -50%) rotate(45deg);
}
::ng-deep .roster_popup .dialogbox__steps {
  padding: 16px 20px;
}
::ng-deep .roster_popup .dialogbox__body {
  padding: 24px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/orgs/orgs.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAzYA;EACE,uBAAA;EACA,iBAAA;AA4YF;AA1YE;EAJF;IAKI,uBAAA;EA6YF;AACF;AA3YE;EARF;IASI,uBAAA;EA8YF;AACF;;AAvYA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA0YF;AAxYE;EAPF;IAQI,sBAAA;IACA,uBAAA;IACA,mBAAA;EA2YF;AACF;AAzYE;EACE,OAAA;AA2YJ;AAxYE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA0YJ;AAvYE;EACE,eAAA;EACA,gBAAA;EACA,cDRiB;ECSjB,SAAA;EACA,uBAAA;EACA,wEDnDS;ECoDT,gBAAA;AAyYJ;AAvYI;EATF;IAUI,eAAA;EA0YJ;AACF;AAvYE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,8DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDtES;ECuET,sBAAA;AAyYJ;AAvYI;EACE,8DAAA;AAyYN;AAtYI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;AAwYN;;AA/XA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,WDxDkB;AC0bpB;AAhYE;EACE,aAAA;EACA,mBAAA;AAkYJ;AAhYI;EACE,YAAA;EACA,aAAA;EACA,WDjEc;ECkEd,eAAA;AAkYN;AA/XI;EACE,cD7Ee;EC8Ef,qBAAA;EACA,4BAAA;AAiYN;AA/XM;EACE,uBDhGQ;ACiehB;AA7XI;EACE,cDlFe;ECmFf,gBAAA;AA+XN;;AAtXA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBDhGoB;ECiGpB,kBAAA;EACA,yBAAA;AAyXF;AAvXE;EAXF;IAYI,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,kBAAA;EA0XF;AACF;AAxXE;EACE,OAAA;EACA,gBAAA;AA0XJ;AAxXI;EAJF;IAKI,eAAA;EA2XJ;AACF;AAxXE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA0XJ;AAxXI;EALF;IAMI,8BAAA;EA2XJ;AACF;;AAnXA;EACE,kBAAA;EACA,WAAA;AAsXF;AApXE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WD7IgB;EC8IhB,eAAA;EACA,oBAAA;AAsXJ;AAnXE;EACE,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wEDlMS;ECmMT,cDhKiB;ECiKjB,gBAAA;EACA,wDAAA;EACA,aAAA;AAqXJ;AAnXI;EACE,WD/Jc;ACohBpB;AAlXI;EACE,8BDxLU;ECyLV,4CAAA;AAoXN;AAhXE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,gBD7KgB;EC8KhB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,iCAAA;AAkXJ;AAhXI;EACE,mBDnMe;ACqjBrB;;AAzWA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA4WF;AA1WE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,WDpNgB;ECqNhB,eAAA;EACA,0BAAA;EACA,eAAA;EACA,UAAA;AA4WJ;AA1WI;EACE,+BAAA;AA4WN;AAzWI;EACE,cDtOe;ECuOf,mBD/NgB;AC0kBtB;AAxWI;EACE,mBDtOe;ECuOf,WAAA;AA0WN;AAxWM;EACE,mBD1Oa;EC2Ob,WAAA;AA0WR;;AAhWA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDtSW;ECuSX,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AAmWF;AAjWE;EACE,6BDvRY;ECwRZ,WAAA;EACA,+BDzRY;AC4nBhB;AAjWI;EACE,mBDtQa;ECuQb,qBDvQa;AC0mBnB;AA/VE;EACE,gBAAA;EACA,cDvRiB;ECwRjB,qBD1QW;AC2mBf;AA/VI;EACE,mBDnRgB;ECoRhB,kBDrRc;ACsnBpB;AA7VE;EACE,gBAAA;EACA,uBDhTY;ECiTZ,8BDjTY;ACgpBhB;AA7VI;EACE,mCAAA;AA+VN;;AAtVA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AAyVF;;AAlVA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAqVF;AAnVE;EACE,eAAA;EACA,mBAAA;AAqVJ;AAlVE;EACE,eAAA;EACA,cD1UiB;EC2UjB,gBAAA;AAoVJ;AAjVE;EACE,kBAAA;AAmVJ;AA/UI;EACE,uBD/VY;ACgrBlB;AA9UI;EACE,cDxVe;ACwqBrB;AA3UI;EACE,WDvVc;ACoqBpB;AA1UI;EACE,WD3Vc;ACuqBpB;;AAnUA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,aAAA;AAsUF;AApUE;EANF;IAOI,0BAAA;IACA,aAAA;IACA,SAAA;EAuUF;AACF;;AA9TI;EACE,gBAAA;AAiUN;AA/TM;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AAiUR;AA9TU;EACE,mBDhYU;ACgsBtB;AA9TY;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD3YO;EC4YP,gCAAA;EACA,gBAAA;EAGA,mBAAA;EACA,wEDzbD;EC0bC,eAAA;AA8Td;AA5Tc;EACE,eAAA;AA8ThB;AA5TgB;EACE,uBD3aF;ACyuBhB;AA3TgB;EACE,gBAAA;EACA,eAAA;AA6TlB;AArTU;EACE,uCAAA;EACA,gCAAA;AAuTZ;AArTY;EACE,yCAAA;AAuTd;AApTY;EACE,0CAAA;AAsTd;AApTc;EACE,yCAAA;AAsThB;AAlTY;EACE,kBAAA;EACA,eAAA;EACA,cD7bO;EC8bP,sBAAA;EACA,gBAAA;AAoTd;AA9Sc;EACE,cDtcK;ECucL,qBAAA;EACA,gBAAA;EACA,4BAAA;AAgThB;AA9SgB;EACE,uBD1dF;AC0wBhB;AAxSU;EACE,mBD7cU;EC8cV,6BAAA;AA0SZ;AAxSY;EACE,kBAAA;EACA,gBAAA;AA0Sd;AAjSE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AAmSJ;AAjSI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDpfe;ECqff,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,wED3hBO;AC8zBb;AAjSM;EACE,mBDnfc;ECofd,kBDrfY;ACwxBpB;AAhSM;EACE,mBD3fa;EC4fb,WAAA;EACA,qBD7fa;AC+xBrB;AAhSQ;EACE,mBAAA;AAkSV;AA9RM;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,WDxgBY;ACwyBpB;AA9RQ;EACE,cAAA;AAgSV;AA7RQ;EACE,gBAAA;AA+RV;AAxRE;EACE,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,cDpiBiB;ECqiBjB,gBAAA;EACA,wEDzkBS;ACm2Bb;AAxRI;EACE,8BDvjBU;ECwjBV,aAAA;AA0RN;AArRE;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBDrkBW;ECskBX,kCAAA;EACA,kBAAA;AAuRJ;AAhRE;EACE,mBAAA;EACA,WAAA;EACA,iCAAA;AAkRJ;AAhRI;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;AAkRN;AA/QI;EACE,mCAAA;EACA,uBDrmBU;ECsmBV,qCAAA;AAiRN;AA/QM;EACE,4BDzmBQ;EC0mBR,WAAA;EACA,sBAAA;AAiRR;AA7QI;EACE,mCAAA;EACA,uBD9mBY;EC+mBZ,qCAAA;AA+QN;AA7QM;EACE,4BDlnBU;ECmnBV,WAAA;EACA,sBAAA;EACA,4CAAA;AA+QR;AA3QI;EACE,oCAAA;EACA,wBD5nBU;EC6nBV,sCAAA;AA6QN;AA3QM;EACE,6BDhoBQ;ECioBR,WAAA;EACA,sBAAA;AA6QR;AAzQI;EACE,mCAAA;EACA,uBDzoBS;EC0oBT,qCAAA;AA2QN;AAzQM;EACE,4BD7oBO;EC8oBP,WAAA;EACA,sBAAA;AA2QR;AArQE;EACE,gBAAA;EACA,cD1oBiB;EC2oBjB,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AAuQJ;AArQI;EACE,+BD/pBU;ECgqBV,wBDhqBU;ACu6BhB;AAlQE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;AAoQJ;AAlQI;EACE,qBAAA;AAoQN;AA/PE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAiQJ;AA/PI;EACE,eAAA;EACA,gBAAA;EACA,cDzqBe;EC0qBf,SAAA;EACA,mBAAA;AAiQN;AA5PE;EACE,eAAA;EACA,gBAAA;EACA,cDnrBiB;ECorBjB,sBAAA;EACA,SAAA;AA8PJ;;AAtPA;EACE,aAAA;AAyPF;AAvPE;EAHF;IAII,mBAAA;EA0PF;AACF;AAxPE;EAPF;IAQI,iBAAA;IACA,oBAAA;EA2PF;AACF;AAzPE;EACE,4BAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;EACA,oCAAA;EACA,6BAAA;EACA,kCAAA;EACA,2BAAA;EACA,iCAAA;EACA,qDAAA;AA2PJ;AAzPI;EACE,0BAAA;AA2PN;AAxPI;EACE,8BAAA;AA0PN;AAtPE;EACE,2BAAA;EACA,yBAAA;AAwPJ;AAtPI;EACE,2BAAA;EACA,oBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,mFAAA;AAwPN;AArPI;EACE,8CAAA;AAuPN;AArPM;EACE,oCAAA;EACA,WDjuBG;ACw9BX;AAlPE;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;AAoPJ;AAjPE;EACE,0BAAA;EACA,4BAAA;AAmPJ;;AA3OA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AA8OF;AA5OE;EACE,yBAAA;AA8OJ;AA3OE;EACE,oCAAA;AA6OJ;AA1OE;EACE,mCAAA;AA4OJ;AAzOE;EACE,UAAA;AA2OJ;AAzOI;EACE,0BAAA;AA2ON;AAvOE;EACE,kBAAA;EACA,gBAAA;AAyOJ;AAtOE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAwOJ;AAtOI;EALF;IAMI,YAAA;IACA,iBAAA;EAyOJ;AACF;AAvOI;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,UAAA;EACA,kBAAA;AAyON;AAvOM;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WDh0BY;ECi0BZ,YAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AAyOR;AAvOQ;EACE,UAAA;EACA,cDh1BW;ACyjCrB;AAtOQ;EACE,aAAA;AAwOV;AApOM;EACE,uBAAA;AAsOR;AAnOU;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cD51BS;ACikCrB;AAlOU;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cD32BS;EC42BT,wED/4BC;ECg5BD,wDAAA;AAoOZ;AAlOY;EACE,WDz2BM;AC6kCpB;AAjOY;EAEE,8BDn4BE;ECo4BF,4CAAA;EACA,aAAA;AAkOd;AA1NE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,wED16BS;EC26BT,0BAAA;EACA,+BDr5BY;ECs5BZ,mCDt5BY;ACknChB;AA1NI;EACE,yBDn4Ba;AC+lCnB;AAzNI;EACE,kCD55BY;EC65BZ,8BD75BY;ACwnClB;AAzNM;EACE,yBAAA;AA2NR;AAvNI;EACE,eAAA;EACA,iBAAA;EACA,kCD16BU;EC26BV,8BD36BU;ACooChB;AAvNM;EACE,yBAAA;AAyNR;AArNI;EACE,kCDl7BS;ECm7BT,8BDn7BS;AC0oCf;AArNM;EACE,yBAAA;AAuNR;AAnNI;EACE,yBAAA;EACA,qBAAA;AAqNN;AAnNM;EACE,yBAAA;AAqNR;AAhNE;EACE,aAAA;AAkNJ;;AA9MA;EACE,gBAAA;AAiNF;;AA1MA;EACE,kBAAA;AA6MF;AA3ME;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBDx8BgB;ECy8BhB,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,2BAAA;EACA,mCAAA;EACA,eAAA;AA6MJ;AA1ME;EACE,cAAA;AA4MJ;AAzME;EACE,kBAAA;AA2MJ;AAzMI;EACE,sBAAA;AA2MN;AAxMI;EACE,WAAA;AA0MN;AAvMI;EACE,cAAA;AAyMN;;AA1LE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,cAAA;AA6LJ;AA1LE;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AA4LJ;AAzLE;EACE,uBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AA2LJ;AAxLE;EACE,kBAAA;EACA,mBDlhCkB;ECmhClB,gCAAA;EACA,kBAAA;AA0LJ;AAxLI;EACE,eAAA;EACA,gBAAA;EACA,cD5hCe;EC6hCf,wEDrkCO;ECskCP,SAAA;AA0LN;AAtLE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAwLJ;AAtLI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAwLN;AArLI;EAAY,+CAAA;AAwLhB;AAvLI;EAAY,8CAAA;AA0LhB;AAvLE;EACE,kBAAA;AAyLJ;AAtLE;EACE,aAAA;AAwLJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"./../../../assets/styles/variables\";\n\n// ─────────────────────────────────────────────\n// Orgs Page Layout\n// ─────────────────────────────────────────────\n\n.orgs-page {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n\n  @media (max-width: 991px) {\n    padding: 24px 28px 36px;\n  }\n\n  @media (max-width: 640px) {\n    padding: 16px 16px 28px;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Header\n// ─────────────────────────────────────────────\n\n.orgs-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin-bottom: 28px;\n  gap: 16px;\n\n  @media (max-width: 640px) {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-bottom: 20px;\n  }\n\n  &__left {\n    flex: 1;\n  }\n\n  &__title-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    letter-spacing: -0.02em;\n    font-family: $font-stack;\n    line-height: 1.2;\n\n    @media (max-width: 640px) {\n      font-size: 22px;\n    }\n  }\n\n  &__count {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    height: 28px;\n    padding: 0 12px;\n    border-radius: 14px;\n    background: linear-gradient(135deg, $clarify-color, darken($clarify-color, 8%));\n    color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: $font-stack;\n    letter-spacing: 0.02em;\n\n    &--search {\n      background: linear-gradient(135deg, $ideate-color, darken($ideate-color, 8%));\n    }\n\n    &-label {\n      font-size: 11px;\n      font-weight: 500;\n      opacity: 0.85;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Breadcrumb\n// ─────────────────────────────────────────────\n\n.orgs-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: $color-neutral-mid;\n\n  li {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child)::after {\n      content: '/';\n      margin: 0 8px;\n      color: $color-neutral-mid;\n      font-size: 11px;\n    }\n\n    a {\n      color: $body-content-color;\n      text-decoration: none;\n      transition: color 0.15s ease;\n\n      &:hover {\n        color: $clarify-color;\n      }\n    }\n\n    &.orgs-breadcrumb__current {\n      color: $color-neutral-dark;\n      font-weight: 600;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Toolbar\n// ─────────────────────────────────────────────\n\n.orgs-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 14px 20px;\n  background: $color-neutral-light;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    padding: 12px 16px;\n  }\n\n  &__left {\n    flex: 1;\n    max-width: 360px;\n\n    @media (max-width: 767px) {\n      max-width: none;\n    }\n  }\n\n  &__right {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    @media (max-width: 640px) {\n      justify-content: space-between;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Search\n// ─────────────────────────────────────────────\n\n.orgs-search {\n  position: relative;\n  width: 100%;\n\n  &__icon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: $color-neutral-mid;\n    font-size: 13px;\n    pointer-events: none;\n  }\n\n  &__input {\n    width: 100%;\n    padding: 9px 36px 9px 34px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    font-size: 13px;\n    font-family: $font-stack;\n    color: $body-content-color;\n    background: #fff;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    outline: none;\n\n    &::placeholder {\n      color: $color-neutral-mid;\n    }\n\n    &:focus {\n      border-color: $clarify-color;\n      box-shadow: 0 0 0 3px rgba($clarify-color, 0.1);\n    }\n  }\n\n  &__clear {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: $color-neutral-mid;\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    width: 18px;\n    height: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 10px;\n    padding: 0;\n    transition: background 0.15s ease;\n\n    &:hover {\n      background: $body-content-color;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// View Toggle\n// ─────────────────────────────────────────────\n\n.orgs-view-toggle {\n  display: flex;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  overflow: hidden;\n  background: #fff;\n\n  &__btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 34px;\n    border: none;\n    background: transparent;\n    color: $color-neutral-mid;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    font-size: 14px;\n    padding: 0;\n\n    &:not(:last-child) {\n      border-right: 1px solid $color-grey-1;\n    }\n\n    &:hover {\n      color: $body-content-color;\n      background: $color-neutral-light;\n    }\n\n    &--active {\n      background: $color-neutral-dark;\n      color: #fff;\n\n      &:hover {\n        background: $color-neutral-dark;\n        color: #fff;\n      }\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Buttons\n// ─────────────────────────────────────────────\n\n.orgs-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-decoration: none;\n  line-height: 1.4;\n\n  &--primary {\n    background: $develop-color;\n    color: #fff;\n    border-color: $develop-color;\n\n    &:hover {\n      background: $color-dark-green;\n      border-color: $color-dark-green;\n    }\n  }\n\n  &--back {\n    background: #fff;\n    color: $body-content-color;\n    border-color: $color-grey-1;\n\n    &:hover {\n      background: $color-neutral-light;\n      border-color: $color-neutral-mid;\n    }\n  }\n\n  &--outline {\n    background: #fff;\n    color: $clarify-color;\n    border-color: $clarify-color;\n\n    &:hover {\n      background: rgba($clarify-color, 0.06);\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Content Area\n// ─────────────────────────────────────────────\n\n.orgs-content {\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n  overflow: hidden;\n  min-height: 200px;\n}\n\n// ─────────────────────────────────────────────\n// States (loading, error, empty)\n// ─────────────────────────────────────────────\n\n.orgs-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n\n  & > i {\n    font-size: 36px;\n    margin-bottom: 16px;\n  }\n\n  p {\n    font-size: 15px;\n    color: $body-content-color;\n    margin: 0 0 16px;\n  }\n\n  &--loading {\n    padding: 48px 20px;\n  }\n\n  &--error {\n    & > i {\n      color: $implement-color;\n    }\n\n    p {\n      color: $body-content-color;\n    }\n  }\n\n  &--empty {\n    & > i {\n      color: $color-neutral-mid;\n    }\n\n    p {\n      color: $color-neutral-mid;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Card View\n// ─────────────────────────────────────────────\n\n.orgs-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n  padding: 24px;\n\n  @media (max-width: 640px) {\n    grid-template-columns: 1fr;\n    padding: 16px;\n    gap: 12px;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Table overrides (roster-table-view child)\n// ─────────────────────────────────────────────\n\n::ng-deep {\n  .orgs-content {\n    .table-responsive {\n      overflow-x: auto;\n\n      table {\n        width: 100%;\n        margin-bottom: 0;\n        border-collapse: collapse;\n\n        thead {\n          tr {\n            background: $color-neutral-light;\n\n            th {\n              padding: 12px 16px;\n              font-size: 11px;\n              font-weight: 700;\n              text-transform: uppercase;\n              letter-spacing: 0.06em;\n              color: $color-neutral-dark;\n              border-bottom: 2px solid $color-grey-1;\n              border-top: none;\n              // Single line. The columns are sized to fit these labels (see .org-table's\n              // colgroup) — letting them wrap put the sort caret on its own row.\n              white-space: nowrap;\n              font-family: $font-stack;\n              cursor: default;\n\n              &.cursor-pointer {\n                cursor: pointer;\n\n                &:hover {\n                  color: $clarify-color;\n                }\n\n                i {\n                  margin-left: 4px;\n                  font-size: 12px;\n                }\n              }\n            }\n          }\n        }\n\n        tbody {\n          tr {\n            transition: background-color 0.12s ease;\n            border-bottom: 1px solid $color-grey-1;\n\n            &:hover {\n              background-color: rgba($clarify-color, 0.03);\n            }\n\n            &:nth-of-type(even) {\n              background-color: rgba($color-neutral-light, 0.5);\n\n              &:hover {\n                background-color: rgba($clarify-color, 0.03);\n              }\n            }\n\n            td {\n              padding: 12px 16px;\n              font-size: 13px;\n              color: $body-content-color;\n              vertical-align: middle;\n              border-top: none;\n\n              // Plain text links only. The icon actions (.invn-act) and the numeric cell links\n              // (.invn-link / .invn-keynum) own their colours — this rule outscores their class\n              // selectors, so without the :not() it repaints them dark and forces Clarify over\n              // the white icon on a filled hover.\n              a:not(.invn-act):not(.invn-keynum) {\n                color: $body-content-color;\n                text-decoration: none;\n                font-weight: 500;\n                transition: color 0.15s ease;\n\n                &:hover {\n                  color: $clarify-color;\n                }\n              }\n            }\n          }\n        }\n\n        tfoot {\n          tr {\n            background: $color-neutral-light;\n            border-top: 1px solid $color-grey-1;\n\n            td {\n              padding: 12px 16px;\n              border-top: none;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Pagination\n  #holder {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 2px;\n\n    & > li {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 32px;\n      height: 32px;\n      padding: 0 8px;\n      border: 1px solid $color-grey-1;\n      border-radius: 4px;\n      font-size: 13px;\n      font-weight: 500;\n      color: $body-content-color;\n      background: #fff;\n      cursor: pointer;\n      transition: all 0.15s ease;\n      font-family: $font-stack;\n\n      &:hover {\n        background: $color-neutral-light;\n        border-color: $color-neutral-mid;\n      }\n\n      &.active {\n        background: $color-neutral-dark;\n        color: #fff;\n        border-color: $color-neutral-dark;\n\n        &:hover {\n          background: darken($color-neutral-dark, 5%);\n        }\n      }\n\n      &.separator {\n        border: none;\n        background: none;\n        cursor: default;\n        min-width: auto;\n        padding: 0 4px;\n        color: $color-neutral-mid;\n\n        &::before {\n          content: '...';\n        }\n\n        &:hover {\n          background: none;\n        }\n      }\n    }\n  }\n\n  // Per-page select\n  .wide-per-page {\n    width: 70px;\n    display: inline-block;\n    padding: 4px 8px;\n    font-size: 13px;\n    border: 1px solid $color-grey-1;\n    border-radius: 4px;\n    color: $body-content-color;\n    background: #fff;\n    font-family: $font-stack;\n\n    &:focus {\n      border-color: $clarify-color;\n      outline: none;\n    }\n  }\n\n  // Sample badge\n  .sample {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 8px;\n    padding: 2px 8px;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: $ideate-color;\n    background: rgba($ideate-color, 0.1);\n    border-radius: 3px;\n  }\n\n  // Action buttons in table.\n  // NOT display:flex — a flex <td> stops being a table cell, so the <colgroup> width is\n  // ignored and the column sizes itself to its content. The inner .invn-acts does the\n  // laying out instead.\n  .team-actions {\n    white-space: nowrap;\n    width: auto;\n    vertical-align: middle !important;\n\n    &__opr {\n      display: inline-flex !important;\n      align-items: center;\n      justify-content: center;\n      width: 30px;\n      height: 30px;\n      padding: 0;\n      border-radius: 6px;\n      font-size: 13px;\n      transition: all 0.2s ease;\n      border: 1px solid transparent;\n      cursor: pointer;\n      line-height: 1;\n    }\n\n    .btn-info {\n      background: rgba($clarify-color, 0.08);\n      color: $clarify-color;\n      border-color: rgba($clarify-color, 0.15);\n\n      &:hover {\n        background: $clarify-color;\n        color: #fff;\n        transform: scale(1.08);\n      }\n    }\n\n    .btn-danger {\n      background: rgba($implement-color, 0.08);\n      color: $implement-color;\n      border-color: rgba($implement-color, 0.15);\n\n      &:hover {\n        background: $implement-color;\n        color: #fff;\n        transform: scale(1.08);\n        box-shadow: 0 2px 8px rgba($implement-color, 0.3);\n      }\n    }\n\n    .btn-primary {\n      background: rgba($develop-color, 0.08);\n      color: $develop-color;\n      border-color: rgba($develop-color, 0.15);\n\n      &:hover {\n        background: $develop-color;\n        color: #fff;\n        transform: scale(1.08);\n      }\n    }\n\n    .btn-warning {\n      background: rgba($ideate-color, 0.08);\n      color: $ideate-color;\n      border-color: rgba($ideate-color, 0.15);\n\n      &:hover {\n        background: $ideate-color;\n        color: #fff;\n        transform: scale(1.08);\n      }\n    }\n  }\n\n  // Add Members button in table\n  .f-btn--bgw {\n    background: #fff;\n    color: $body-content-color;\n    border: 1px solid $color-grey-1;\n    padding: 4px 12px;\n    font-size: 11px;\n    font-weight: 600;\n    border-radius: 4px;\n    transition: all 0.15s ease;\n\n    &:hover {\n      border-color: $develop-color;\n      color: $develop-color;\n    }\n  }\n\n  // Group profile image\n  .group-profile-img {\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    transition: transform 0.15s ease;\n\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n\n  // Form label in footer\n  .form-group {\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    label {\n      font-size: 12px;\n      font-weight: 600;\n      color: $color-neutral-dark;\n      margin: 0;\n      white-space: nowrap;\n    }\n  }\n\n  // Search result heading\n  .search-res {\n    font-size: 16px;\n    font-weight: 600;\n    color: $color-neutral-dark;\n    padding: 16px 16px 8px;\n    margin: 0;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Swal overrides (scoped)\n// ─────────────────────────────────────────────\n\n::ng-deep .swal2-container {\n  padding: 30px;\n\n  @media #{$mobile-up} {\n    padding-left: 220px;\n  }\n\n  @media #{$mobile} {\n    padding-top: 50px;\n    padding-inline: 15px;\n  }\n\n  .swal2-modal {\n    align-self: start !important;\n    grid-row: auto !important;\n    height: auto !important;\n    margin: 0 !important;\n    border: 1px solid $color-grey-1 !important;\n    border-radius: 8px !important;\n    padding: 20px 28px 22px !important;\n    position: static !important;\n    background-color: $clrWhite !important;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08) !important;\n\n    & > * {\n      margin-block: 0 !important;\n    }\n\n    & > :not(:last-child) {\n      margin-bottom: 14px !important;\n    }\n  }\n\n  .swal2-actions {\n    margin-bottom: 0 !important;\n    grid-gap: 10px !important;\n\n    button {\n      min-width: 130px !important;\n      margin: 0 !important;\n      font-size: 13px !important;\n      font-weight: 600 !important;\n      padding: 10px 20px !important;\n      border-radius: 6px !important;\n      font-family: $font-stack !important;\n    }\n\n    .swal2-confirm {\n      background-color: $develop-color !important;\n\n      &:hover {\n        background-color: $color-dark-green !important;\n        color: $clrWhite;\n      }\n    }\n  }\n\n  h2 {\n    font-size: 18px !important;\n    line-height: 1.3 !important;\n    font-weight: 600 !important;\n    color: $color-neutral-dark !important;\n  }\n\n  .swal2-html-container {\n    font-size: 14px !important;\n    line-height: 150% !important;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Modal overrides\n// ─────────────────────────────────────────────\n\n::ng-deep .modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n\n  &.show {\n    display: block !important;\n  }\n\n  &.grey {\n    background: rgba(236, 236, 236, 0.9);\n  }\n\n  &.fade .modal-dialog {\n    transition: transform 0.3s ease-out;\n  }\n\n  &.in {\n    opacity: 1;\n\n    .modal-dialog {\n      transform: translate(0, 0);\n    }\n  }\n\n  &.modal-open {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  .modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 10px;\n\n    @media (min-width: 768px) {\n      width: 560px;\n      margin: 60px auto;\n    }\n\n    .modal-content {\n      background: #fff;\n      border: 1px solid $color-grey-1;\n      border-radius: 8px;\n      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n      outline: 0;\n      position: relative;\n\n      .close {\n        float: right;\n        font-size: 20px;\n        font-weight: bold;\n        color: $color-neutral-mid;\n        opacity: 0.6;\n        border: none;\n        background: transparent;\n        padding: 0;\n        cursor: pointer;\n\n        &:hover {\n          opacity: 1;\n          color: $body-content-color;\n        }\n\n        &:focus-visible {\n          outline: none;\n        }\n      }\n\n      .modal-body {\n        padding: 24px 28px 28px;\n\n        form {\n          label {\n            display: block;\n            margin-bottom: 6px;\n            font-size: 13px;\n            font-weight: 600;\n            color: $color-neutral-dark;\n          }\n\n          input[type=\"text\"] {\n            width: 100%;\n            padding: 10px 14px;\n            font-size: 14px;\n            border: 1px solid $color-grey-1;\n            border-radius: 6px;\n            background: #fff;\n            color: $body-content-color;\n            font-family: $font-stack;\n            transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n            &::placeholder {\n              color: $color-neutral-mid;\n            }\n\n            &:focus,\n            &:focus-visible {\n              border-color: $clarify-color;\n              box-shadow: 0 0 0 3px rgba($clarify-color, 0.1);\n              outline: none;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .f-btn {\n    color: #fff;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 6px;\n    padding: 10px 20px;\n    border: none;\n    cursor: pointer;\n    font-family: $font-stack;\n    transition: all 0.15s ease;\n    border-color: $develop-color;\n    background-color: $develop-color;\n\n    &:hover {\n      background-color: $color-dark-green;\n    }\n\n    &--dngr {\n      background-color: $implement-color;\n      border-color: $implement-color;\n\n      &:hover {\n        background-color: darken($implement-color, 8%);\n      }\n    }\n\n    &--info {\n      font-size: 12px;\n      padding: 6px 12px;\n      background-color: $clarify-color;\n      border-color: $clarify-color;\n\n      &:hover {\n        background-color: darken($clarify-color, 8%);\n      }\n    }\n\n    &--wrng {\n      background-color: $ideate-color;\n      border-color: $ideate-color;\n\n      &:hover {\n        background-color: darken($ideate-color, 8%);\n      }\n    }\n\n    &--seagrn {\n      background-color: #1dc5a3;\n      border-color: #1dc5a3;\n\n      &:hover {\n        background-color: darken(#1dc5a3, 5%);\n      }\n    }\n  }\n\n  .hidden {\n    display: none;\n  }\n}\n\n::ng-deep .modal-open {\n  overflow: hidden;\n}\n\n// ─────────────────────────────────────────────\n// Reset input (column filter legacy support)\n// ─────────────────────────────────────────────\n\n.reset-input {\n  position: relative;\n\n  .reset-close {\n    display: none;\n    position: absolute;\n    top: 0;\n    right: 15px;\n    bottom: 0;\n    margin: auto;\n    border-radius: 50%;\n    background: $color-neutral-mid;\n    border: none !important;\n    text-align: center;\n    font-size: 12px;\n    padding: 0 !important;\n    height: 16px !important;\n    width: 16px !important;\n    color: #fff;\n    line-height: 1.2 !important;\n    transform: rotate(45deg) !important;\n    cursor: pointer;\n  }\n\n  &:hover .reset-close {\n    display: block;\n  }\n\n  th {\n    position: relative;\n\n    input[type=\"search\"] {\n      width: 100% !important;\n    }\n\n    .reset-close {\n      right: 25px;\n    }\n\n    &:hover .reset-close {\n      display: block;\n    }\n  }\n}\n\n// Production (v16.1.993) shipped a fuller version of the overlay fix this branch had:\n// same purpose, but it also styles the close button, header, steps and body, so it is\n// kept over ours. Left global rather than :host-scoped, as production has it — the\n// .roster_popup namespace makes a collision unlikely.\n// ── Roster add-member popup overlay (opened from orgs page) ──\n// The dialogbox overlay styles live in org-individual-teams.component.scss with\n// view encapsulation, so they don't reach this context. Mirror them here via\n// ::ng-deep so the popup renders as a fixed overlay when triggered from the\n// table/card views on this page.\n::ng-deep .roster_popup {\n  .dialogbox {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4);\n    z-index: 99999;\n  }\n\n  .dialogbox__wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    padding: 60px 20px;\n    overflow-y: auto;\n    height: 100%;\n  }\n\n  .dialogbox__inner {\n    width: min(560px, 100%);\n    border-radius: 10px;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n    overflow: hidden;\n    background: #fff;\n    border: none;\n    padding: 0;\n  }\n\n  .dialogbox__hdr {\n    padding: 18px 24px;\n    background: $color-neutral-light;\n    border-bottom: 1px solid $color-grey-1;\n    position: relative;\n\n    h2 {\n      font-size: 17px;\n      font-weight: 700;\n      color: $color-neutral-dark;\n      font-family: $font-stack;\n      margin: 0;\n    }\n  }\n\n  .dialogbox__close {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n\n    &::before, &::after {\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 2px;\n      height: 55%;\n      background-color: #676a6c;\n      border-radius: 2px;\n    }\n\n    &::before { transform: translate(-50%, -50%) rotate(-45deg); }\n    &::after  { transform: translate(-50%, -50%) rotate(45deg); }\n  }\n\n  .dialogbox__steps {\n    padding: 16px 20px;\n  }\n\n  .dialogbox__body {\n    padding: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
